import { useLanguageContext } from "../../../context/LanguageContext";
import useFileCreateRouteConfig from "../../../routes/configs/files/FileCreateRouteConfig";
import useFileEditRouteConfig from "../../../routes/configs/files/FileEditRouteConfig";
import DataTable, { useDataTable } from "../main/DataTable";
import useBasicColumnConfig from "../main/config/column/default/BasicColumnConfig";
import useFileColumnConfig from "../main/config/column/default/FileColumnConfig";
import useTimestampColumnConfig from "../main/config/column/default/TimestampColumnConfig";
import DataTableConfig from "../main/config/dataTable/DataTableConfig";
import useCreateHeaderActionConfig from "../main/config/headerAction/default/CreateHeaderActionConfig";
import useDeleteRowActionConfig from "../main/config/rowAction/default/DeleteRowActionConfig";
import useEditRowActionConfig from "../main/config/rowAction/default/EditRowActionConfig";

function FilesDataTable() {
  const { translate } = useLanguageContext();

  //Create the datatable config
  const config = new DataTableConfig("files");

  //Set the datatable fetch info
  config.setFetchRequest("files");

  //Set the datatable order by
  config.setOrderBy("type");
  config.setOrderDirection("asc");

  //Set the datatable columns
  config.setColumns([
    useFileColumnConfig("file", (row) => row, "file"),
    useBasicColumnConfig("name").setLockActive(true),
    useBasicColumnConfig("type.translation").setData((row) =>
      translate("eva.main.file_types." + row.type)
    ),
    useTimestampColumnConfig("created_at"),
    useTimestampColumnConfig("updated_at"),
  ]);

  //Set the datatable row actions
  config.setRowActions([
    useEditRowActionConfig("file", useFileEditRouteConfig()),
    useDeleteRowActionConfig("file"),
  ]);

  //Set the datatable header actions
  config.setHeaderActions([
    useCreateHeaderActionConfig("file", useFileCreateRouteConfig()),
  ]);

  //Create the datatable object
  const dataTable = useDataTable(config);

  return <DataTable controller={dataTable} />;
}

export default FilesDataTable;
